import { useContext } from "react";
import clsx from "clsx";
import { LoadingIndicator } from "@k8slens/lds";
import { useGetBusinessSubscriptions } from "src/hooks/useGetBusinessSubscriptions";

import { BusinessContext } from "src/components/Business/Base";
import Notification from "src/components/Notification/Notification";
import TrackedAnchor from "src/components/TrackedAnchor/TrackedAnchor";

import { BusinessSSO } from "./BusinessSSO";

import styles from "./SingleSignOn.module.css";
import { hasActiveLensPro } from "src/services/hasActiveLensPro";

export const SingleSignOn = () => {
  const { businessId, business } = useContext(BusinessContext);

  const { loading, businessSubscriptions } = useGetBusinessSubscriptions(businessId);
  const businessHasActiveLensPro = hasActiveLensPro(businessSubscriptions);

  return (
    <>
      <header>
        <h3 className="lds-h3">Single Sign-On</h3>
        <p>Manage single sign-on for your Business here.</p>
      </header>
      {!businessHasActiveLensPro ? (
        <Notification
          level="info"
          className={styles.enterpriseAccNotification}
          message={
            <>
              {"Please "}
              <TrackedAnchor href="/subscribe">subscribe</TrackedAnchor>
              {" to enable sign sign-on."}
            </>
          }
        />
      ) : null}
      {loading ? (
        <LoadingIndicator size="2xl" />
      ) : (
        <section
          className={clsx({
            [styles.disabledSection]: !businessHasActiveLensPro,
          })}
        >
          {<BusinessSSO business={business} />}
        </section>
      )}
    </>
  );
};
